// extracted by mini-css-extract-plugin
export default {"contentContainer":"MainTemplate_Admin_contentContainer__61ZE+","tableContent":"MainTemplate_Admin_tableContent__dOyOz"};